var s = (e, o, t) => new Promise((c, a) => {
  var p = (r) => {
    try {
      n(t.next(r));
    } catch (i) {
      a(i);
    }
  }, d = (r) => {
    try {
      n(t.throw(r));
    } catch (i) {
      a(i);
    }
  }, n = (r) => r.done ? c(r.value) : Promise.resolve(r.value).then(p, d);
  n((t = t.apply(e, o)).next());
});
import { selfAxios as f } from "@oppein/op-utils";
function A(e) {
  return s(this, null, function* () {
    const {
      data: o
    } = yield f.post(
      "/designordercenter/productionOrder/aiOperation/createAiUrgent",
      e
    );
    return o;
  });
}
export {
  A as postCreateAiUrgent
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/aiOperation/createAiUrgent/post.js
// module id = 1811
// module chunks = 67